export default {
    "scales": {
        "scale": {
            "showName": "Шкала",
            "templatesFolder": "componentsCompany/smz/elementScales/scale"
        }
    }
}